import * as appConfig from '../config'
import UIBlock from "../class/UIBlock";
import Level from "./level";

export default class Bar extends UIBlock {
    constructor(config) {
        super()
        this.scene = config.scene;
        this.grid = config.grid;
        this.config = appConfig.other.progressBar
        this.progressBox = this.scene.add.graphics();
        this.progressBox.fillStyle(0x000000, 1);
        this.progressBox.strokeRoundedRect(0, 0, this.config.width, this.config.height, 10)
            .lineStyle(2, 0xffffff);
        this.grid.placeAtIndex(199, this.progressBox)
        this.createProgressBar(0);

        let projectsText = this.scene.add.text(
            this.progressBox.x + this.config.width + 30,
            this.progressBox.y + 30,
            `Проекты ${appConfig.other.projects.level}/10`,
            {
                fontSize: '32px',
            });
    }

    updateProgress(balls) {
        let percent = balls / appConfig.other.progressBar.toWin;
        let value = this.config.width * percent;
        if (percent >= 1) {
            Level.nextLevel();
            this.scene.scene.restart();
        }
        if (this.progressBar) {
            this.progressBar.clear()
        }
        if (value <= 0) {
            this.createProgressBar(0)
        } else {
            this.createProgressBar(value)
        }
    }

    createProgressBar(value) {
        if (value > 0) {
            window.progressBar = this.progressBar = this.scene.add.graphics();
            this.progressBar.fillStyle(0x701fb4, 1);
            if (value === this.config.width) {
                this.progressBar.fillRoundedRect(0, 0, value, this.config.height, 10)
            } else {
                this.progressBar.fillRoundedRect(0, 0, value, this.config.height, {
                    tl: 10, bl: 10, br: 0, tr: 0,
                })
            }
            this.progressBar.strokeRoundedRect(0, 0, this.config.width, this.config.height, 10)
                .lineStyle(2, 0xffffff);
                this.grid.placeAtIndex(199, this.progressBar)
        }
    }


}

